module.exports = __webpack_public_path__ + "static/service-8605162bf06812af5de4791386d0409a.svg";